export function isFloat(value) {
  return Number(value) === value && value % 1 !== 0;
}

export function isContainUppercase(str) {
  return (/[A-Z]/.test(str));
}

export function countSubstring(str, subs) {
  let foundSize = str.split(subs).length - 1
  return foundSize;
}

export function isContainSubstring(str, subs) {
  let found = countSubstring(str, subs) > 0 ? true : false;
  return found;
}

export function hasWhiteSpace(str) {
  if (str.includes(' '))
    return true;
  else
    return false;
}